<template>
  <v-container class="controlled-font">
    <app-confirm ref="confirm"></app-confirm>
    <app-applicant-information
      :displayExamineeImage="true"
      :message="screenMessages.TestSelection"
      :messageEx="screenMessages.TestSelectionEx"
    ></app-applicant-information>
    <v-card class="mx-auto mt-10" elevation="2">
      <app-card-header
        icon="mdi-format-list-bulleted"
        :text="siteText.ui.assignedTests"
        class="controlled-font"
      ></app-card-header>
      <v-card-text class="mx-auto">
        <v-row flex class="mx-2">
          <v-col sm="12">
            <v-simple-table dense class="pt-5">
              <thead>
                <tr>
                  <th class="font-weight-bold text-center controlled-font">
                    {{ siteText.ui.testType }}
                  </th>
                  <th class="font-weight-bold text-center controlled-font">
                    {{ siteText.ui.language }}
                  </th>
                  <th class="font-weight-bold text-center controlled-font">
                    {{ siteText.ui.totalQuestions }}
                  </th>
                  <th class="font-weight-bold text-center controlled-font">
                    {{ siteText.ui.passingScore }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="testAttempt in assignedTestAttempts"
                  :key="testAttempt.registrationNumber"
                >
                  <td class="controlled-font pb-2 text-center">
                    {{ testAttempt.testAttemptId }} -
                    {{ testAttempt.testName }}
                  </td>
                  <td class="controlled-font pb-2 text-center">
                    {{ testAttempt.language }}
                  </td>
                  <td class="controlled-font pb-2 text-center">
                    {{ testAttempt.totalQuestions }}
                  </td>
                  <td class="controlled-font pb-2 text-center">
                    {{ testAttempt.passingScore }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row flex class="mt-5">
      <!--<v-col sm="9"></v-col>-->
      <v-col sm="3">
        <v-btn class="primary controlled-font" @click="startTest">
          {{ startButtonText }}
          <v-icon right>mdi-forward</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import appConfirm from "../components/ui/Confirm.vue";
import appCardHeader from "../components/ui/CardHeader.vue";
import appApplicantInformation from "../components/ApplicantInformation.vue";
import * as consts from "../store/constants";

export default {
  components: {
    appConfirm,
    appCardHeader,
    appApplicantInformation,
  },
  mounted() {},
  data() {
    return {
      NoImage: require("../assets/images/generic_user_image.png"),
      DisplayExamineeImage: true,
      expanded: [0],
    };
  },
  computed: {
    ...mapGetters({
      assignedTestAttempts: "testAttempts",
      selectedLanguage: "selectedLanguage",
      userDetails: "userDetails",
      isDarkTheme: "isDarkTheme",
      siteText: "siteText",
      localeId: "selectedLocaleId",
      screenMessages: "screenMessages",
    }),
    message() {
      let message = this.screenMessages.TestSelection;
      if (this.screenMessages.TestSelectionEx) {
        message += `<p style='padding-top:20px'>${this.screenMessages.TestSelectionEx}</p>`;
      }
      return message;
    },
    startButtonText() {
      const hasTestInProgress = this.assignedTestAttempts.find((v) => {
        return v.status === consts.TEST_STATUSES.PROGRESSING;
      });
      let buttonText = hasTestInProgress
        ? this.siteText.ui.resumeTest
        : this.siteText.ui.startTest;

      return buttonText;
    },
  },
  methods: {
    ...mapActions({
      _startTest: "startTest",
      setSystemError: "setSystemErrorMessage",
      finished: "finished",
      setStartPage: "setStartPage",
    }),
    async startTest() {
      const _this = this;
      const testAttempt = await this._startTest();
      console.log(this.screenMessages);
      if (
        testAttempt.status !== consts.TEST_STATUSES.PROGRESSING ||
        testAttempt.kioskUnAssigned
      ) {
        const message =
          testAttempt.status === consts.TEST_STATUSES.CANCELLED
            ? this.screenMessages.CancelledTest
            : !testAttempt.kioskUnAssigned
            ? this.screenMessages.SuspendedTest
            : this.screenMessages.TestUnassigned;
        this.$emit("show-alert", {
          message: message,
          callback: function() {
            _this.finished();
          },
        });
      } else {
        console.log("Starting Test");
        this.setStartPage();
      }
    },
  },
};
</script>

<style scoped>
th,
td {
  border: none !important;
  color: black !important;
}
.applicant-image {
  max-width: 125px;
}
.v-chip {
  min-width: 250px !important;
}

.v-expansion-panel-header {
  color: white;
}

.v-card__text {
  color: black !important;
}
</style>
